import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";

export const IconButtonStyled = styled(IconButton)`
    margin-left: 16px;
    background-color: ${colorsPalettes.indigo[300]};
`;

export const ButtonStyled = styled(Button)`
    margin-left: 16px;
    background-color: ${colorsPalettes.indigo[300]};
`;
